import { useCallback } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { getCenterLocation, getCenterInfo } from 'app/store/modules/encarcenter';

export default function useCenter() {
	const { locationList, centerList, totalCount } = useSelector((state) => state.encarcenter, shallowEqual);
	const { pender } = useSelector((state) => state, shallowEqual);

	const dispatch = useDispatch();
	const getLocationData = useCallback((action, signal) => dispatch(getCenterLocation(action, signal)), [dispatch]);
	const getCenterData = useCallback((action, signal) => dispatch(getCenterInfo(action, signal)), [dispatch]);
	const isError = pender.failure['encarcenter/GET_CENTER_INFO'];

	return {
		isError,
		locationList,
		getLocationData,
		centerList,
		totalCount,
		getCenterData,
	};
}
